export const GET_REGION = "GET_REGION";
export const INSERT_REGION = "INSERT_REGION";
export const EDIT_REGION = "EDIT_REGION";
export const DELETE_REGION = "DELETE_REGION";

export const OPEN_REGION_DIALOG = "OPEN_REGION_DIALOG";
export const CLOSE_REGION_DIALOG = "CLOSE_REGION_DIALOG";
export const VIP_SWITCH_REGION = "VIP_SWITCH_REGION";
